import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import ImgCarousel from '../../ui/img/ImgCarousel';

import './QuiSommesNousBanner.scss';

const QuiSommesNousBanner = props => {
  const { carouselImages, aboutBannerTitle, aboutBannerBody } = props;
  //! Attention : Il faut absolument que les images aient les mêmes dimensions.
  //! A gérer dans Contentful directement

  return (
    <div className={(props.className || '') + ' offshore-about'}>
      <div className="row">
        <div className="col-md-6">
          <h1>{aboutBannerTitle}</h1>
          <div dangerouslySetInnerHTML={{ __html: aboutBannerBody }} />
        </div>
        <div className="col-md-6">
          <ImgCarousel images={carouselImages} />
        </div>
      </div>
    </div>
  );
};

QuiSommesNousBanner.propTypes = {
  className: PropTypes.string,
  carouselImages: PropTypes.array,
  aboutBannerTitle: PropTypes.string,
  aboutBannerBody: PropTypes.string,
};

export default QuiSommesNousBanner;



// WEBPACK FOOTER //
// ./src/components/Main/home/QuiSommesNousBanner.js